'use client';

import type { TypographyProps as BaseTypographyProps } from '@polyseme/design-system';

import { Typography as BaseTypography } from '@polyseme/design-system';
import { useSearchParams } from 'next/navigation';

import {
  FONT_FAMILIES,
  FONT_FAMILY_MAP,
  type FontFamily,
} from '~/landing/lib/theme-constants';

export const DynamicFontTypography = ({
  style,
  ...props
}: BaseTypographyProps) => {
  const searchParams = useSearchParams();
  const fontParam = searchParams.get('font');

  const dynamicFont: FontFamily =
    fontParam && FONT_FAMILIES.some((font) => font === fontParam)
      ? (fontParam as FontFamily)
      : 'inter';

  const styleWithDynamicFont = {
    ...style,
    fontFamily: FONT_FAMILY_MAP[dynamicFont],
  };

  return <BaseTypography style={styleWithDynamicFont} {...props} />;
};
